import React, { useState } from 'react';
import { IconWrapper } from '@flexo/general';
import styles from './rating.module.scss';
interface StarRatingProps {
  onChange?: (rating: number | null) => void;
}

export const StarRating: React.FC<StarRatingProps> = ({ onChange }) => {
  const { Rating__Star, Rating__Star__Clicked } = styles;
  const [rating, setRating] = useState<number | null>(null);
  const [hover, setHover] = useState<number | null>(null);

  const handleStarClick = (selectedRating: number) => {
    if (rating === selectedRating) {
      setRating(null);
      if (onChange) {
        onChange(null);
      }
    } else {
      setRating(selectedRating);
      if (onChange) {
        onChange(selectedRating);
      }
    }
  };

  const handleStarHover = (hoverRating: number) => {
    setHover(hoverRating);
  };

  const handleStarLeave = () => {
    setHover(null);
  };

  const isStarClicked = (starValue: number) => {
    return rating !== null && starValue <= rating;
  };

  return (
    <div>
      <div style={{ display: 'flex' }}>
        {[...Array(5)].map((_, i) => {
          const starValue = i + 1;
          const isClicked = isStarClicked(starValue);
          const isHovered = hover !== null && starValue <= hover;
          const starClassName = `${Rating__Star} ${
            isClicked || isHovered ? Rating__Star__Clicked : ''
          }`;
          return (
            <div
              key={i}
              onClick={() => handleStarClick(starValue)}
              onMouseEnter={() => handleStarHover(starValue)}
              onMouseLeave={handleStarLeave}
              className={starClassName}
            >
              <IconWrapper
                iconName="star-feedback_outline"
                style={{ marginRight: 5 }}
              />

            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StarRating;
